export default __webpack_public_path__ + "static/media/couple.7abb0d36.jpg";